import { useToast } from '@chakra-ui/react'
import useBrands from '../../../../hooks/useBrands'
import useConfigList from '../../../../hooks/useConfigList'
import useNavigateNext from '../../../../hooks/useNavigateNext'
import useUpdateReportDoc from '../../../../hooks/useUpdateReportDoc'
import useCurrentReport from '../../../../hooks/useCurrentReport'
import { SupplementsFormState } from '../utils/types'

export const useSupplementsFormState = (): SupplementsFormState => {
  const toast = useToast()
  const items = useConfigList('supplements')
  const brands = useBrands()
  const navNext = useNavigateNext()
  const updateReport = useUpdateReportDoc()
  const currentReport = useCurrentReport()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!currentReport?.supplementListIsAccurate) {
      toast({
        status: 'warning',
        title: 'Supplement List Accurate?',
        description: `Please check the box confirming your supplement list is currently accurate.`,
      })
      return false
    }
    updateReport({ supplements: true })
    navNext()
  }

  const lists = [
    {
      fieldId: 'supplementId',
      label: 'Supplement',
      items,
      id: 'supplements',
    },
    {
      fieldId: 'brandId',
      label: 'Brand',
      items: brands,
      id: 'brands',
    },
  ]

  return {
    handleSubmit,
    lists,
  }
}
